import React from "react";
import { Container } from "@raketa-cms/raketa-cms";
import {
  ChangeOfPersonalInformation,
  LeaveOfAbsence,
  LetterOfCompletion,
  LetterOfReference,
  Other,
  Transcript,
  UpdateFerpa,
  VerificationOfEnrollment,
} from "./forms";
import { Select } from "./inputs";

const FORMS = {
  ChangeOfPersonalInformation,
  VerificationOfEnrollment,
  LetterOfCompletion,
  LetterOfReference,
  UpdateFerpa,
  Transcript,
  LeaveOfAbsence,
  Other,
};

const StudentRequestFormWidget = ({ containerSettings }) => {
  const [form, setForm] = React.useState(undefined);

  const SubFormComponent = FORMS[form] || false;

  const handleChangeForm = (e) => setForm(e.target.value);

  return (
    <Container settings={containerSettings}>
      <div className="container">
        <div className="row">
          <div className="shift-3 stars-form">
            <Select
              label="Which type of request are you submitting?"
              options={[
                ["ChangeOfPersonalInformation", "Change of personal information"],
                ["VerificationOfEnrollment", "Verification of enrollment"],
                ["LetterOfCompletion", "Letter of completion"],
                ["LetterOfReference", "Letter of reference"],
                ["UpdateFerpa", "Update FERPA release form"],
                ["Transcript", "Transcript"],
                ["LeaveOfAbsence", "Leave of absence"],
                ["Other", "Other"],
              ]}
              value={form}
              onChange={handleChangeForm}
            />
            <div>{SubFormComponent && <SubFormComponent />}</div>
          </div>
        </div>
      </div>
    </Container>
  );
};

StudentRequestFormWidget.title = "Student Request Form";
StudentRequestFormWidget.category = "Forms";
StudentRequestFormWidget.defaults = {};

export default StudentRequestFormWidget;
